import React, { useState, useEffect } from "react";
import classes from "./freeTrialForm.module.css";
import InputField from "../../../containers/inputField/inputField";
import { sixYardAxios } from "../../../../sixYardAxios";
import PromptMessage from "../../../containers/promptMessage/promptMessage";

function FreeTrialForm(props) {
  const locationsList = props.academy?.locations?.map(location => ({
    value: location.id,
    displayValue: location.name,
  })) || [];
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  // Move the controls definition to a function
  const getInitialControls = () => ({
    phone: {
      elementType: "input",
      elementConfig: {
        type: "phone",
        placeholder: "07xxxxxxxx",
        options: []
      },
      value: "",
      valueName: "phone_number",
      validation: {
        required: true,
        isNumeric: true
      },
      label: parseInt(localStorage.getItem('language')) === 1 ? "Phone Number" : "رقم الهاتف",
      valid: false,
      touched: false
    },
    kidsName: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter name" : "أدخل الاسم",
      },
      value: "",
      validation: {
        required: true,
        minLength: 6,
        maxLength: 32,
      },
      label: parseInt(localStorage.getItem('language')) === 1 ? "Kid's Full Name" : "الاسم الكامل للطفل",
      valid: false,
      touched: false
    },
    kidsAge: {
      elementType: "input",
      elementConfig: {
        type: "number",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter age" : "أدخل العمر",
      },
      value: "",
      validation: {
        required: true,
        minLength: 6,
        maxLength: 32,
      },
      label: parseInt(localStorage.getItem('language')) === 1 ? "Kid's Age" : "عمر الطفل",
      valid: false,
      touched: false
    },
    location: {
      elementType: "select",
      elementConfig: {
        type: "select",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Choose location" : "اختر الموقع",
        options: locationsList
      },
      value: "",
      validation: {
        required: true,
      },
      label: parseInt(localStorage.getItem('language')) === 1 ? "Location" : "الموقع",
      valid: false,
      touched: false
    },
    dateOfTrial: {
      withIcon: true,
      elementType: "input",
      elementConfig: {
        type: "calendarDate",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Select date" : "اختر التاريخ",
      },
      availableDates: props.academy?.trial_slots,
      value: "",
      validation: {
        required: true,
      },
      label: parseInt(localStorage.getItem('language')) === 1 ? "Date Of Trial" : "تاريخ التجربة",
      valid: false,
      touched: false
    },
    // time: {
    //   elementType: "select",
    //   elementConfig: {
    //     type: "text",
    //     placeholder: "Select time",
    //     options: []
    //   },
    //   value: "",
    //   validation: {
    //     required: true,
    //   },
    //   label: "Time",
    //   valid: false,
    //   touched: false
    // },
  });

  const [controls, setControls] = useState(getInitialControls());

  // Add useEffect to update controls when language changes
  useEffect(() => {
    setControls(getInitialControls());
  }, [localStorage.getItem('language')]);

  useEffect(() => {
    if (props.academy?.locations) {
      setControls(prevControls => ({
        ...prevControls,
        location: {
          ...prevControls.location,
          elementConfig: {
            ...prevControls.location.elementConfig,
            options: props.academy.locations.map(location => ({
              value: location.id,
              displayValue: location.name,
            })),
          },
        },
      }));
    }
  }, [props.academy?.locations]);
 
    
  useEffect(() => {
    setControls(prevControls => ({
      ...prevControls,
      dateOfTrial: {
        ...prevControls.dateOfTrial,
        availableDates: props.academy?.trial_slots
      }
    }));
  }, [props.academy?.trial_slots]);
// useEffect(() => {
//   controls.dateOfTrial.value.length > 0 && handleDateSelection(controls.dateOfTrial.value)
// }, [controls.dateOfTrial.value]);

  const formElementsArray = [];
  for (let key in controls) {
    formElementsArray.push({
      id: key,
      config: controls[key]
    });
  }
  const form = formElementsArray.map((formElement, i) => (
    <div key={i} className={[classes.FormGroup, formElement.id === "dateOfTrial" && classes.FormGroupCalendar].join(" ")}>
      <InputField
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        availableDates={formElement.config.availableDates}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        withRemove={false}
        withIcon={formElement.config.withIcon}
        label={formElement.config.label}
        changed={event => inputChangedHandler(event, formElement.id)}
      />
    </div>
  ));
  const checkValidity = ((value, rules) => {
    let isValid = true;
    if (!rules) {
      return true;
    }

    if (rules.required) {
      value = typeof value === 'string' ? value.trim() : value;
      isValid = value !== "" && isValid;
    }

    if (rules.minLength) {
      isValid = value?.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value?.length <= rules.maxLength && isValid;
    }

    if (rules.isNumeric) {
      const pattern = /^\d+$/;
      isValid = pattern.test(value) && isValid;
    }

    return isValid;
  });
//   const handleDateSelection = (selectedDate) => {        
//     const selectedSlots = props.academy?.trial_slots?.find(
//         (slot) => slot.date === selectedDate[0]
//     );

//     // Update time options
//     const updatedOptions = selectedSlots
//         ? selectedSlots.times.map((slot) => ({
//             value: slot.time,
//             displayValue: slot.time,
//         }))
//         : [];
//     const updatedControls = {
//         ...controls,
//         time: {
//             ...controls.time,
//             elementConfig: {
//                 ...controls.time.elementConfig,
//                 options: updatedOptions
//             }
//         }
//     };
//     setControls(updatedControls);
// };
  const inputChangedHandler = (event, controlName) => {
    const value = (controlName === 'phone' || controlName === 'dateOfTrial') ? event : event.target.value;
    setControls(prevControls => ({
      ...prevControls,
      [controlName]: {
        ...prevControls[controlName],
        value,
        valid: checkValidity(value, prevControls[controlName].validation),
        touched: true
      }
    }));
  };
  const clearControls = () => {
    const updatedControls = {
      ...controls
    };
    for (let key in controls) {
      updatedControls[key] = {
        ...controls[key],
        value: "",
        valid: false,
        touched: false
      };
    }
    setControls(updatedControls);
  };
  const submitHandler = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const formData = {
        phone: controls.phone.value.dialCode+controls.phone.value.number,
        kid_name: controls.kidsName.value,
        age: controls.kidsAge.value,
        location_id: controls.location.value,
        date: controls.dateOfTrial.value[0],
        // time: controls.time.value,
        interval_id: 1
      };
      const response = await sixYardAxios.post('/academy/training/register', formData);
      if (response.data.data) {
        clearControls();
        setSuccess(response.data.data.message || 
          (parseInt(localStorage.getItem('language')) === 1 
            ? 'Your order was submitted successfully. We will reach you soon'
            : 'تم تقديم طلبك بنجاح. سنتواصل معك قريباً'));
      }
    } catch (err) {
      setError(err.response?.data?.message || 
        (parseInt(localStorage.getItem('language')) === 1 
          ? 'Something went wrong. Please try again.'
          : 'حدث خطأ ما. الرجاء المحاولة مرة أخرى.'));
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className={classes.freeTrialForm}>
      <h2 className={classes.sectionTitle}>
        {parseInt(localStorage.getItem('language')) === 1 
          ? "Book your free trial"
          : "احجز تجربتك المجانية"}
      </h2>
      <p className={classes.description}>
        {parseInt(localStorage.getItem('language')) === 1 
          ? "Get your free class and try training with us"
          : "احصل على حصتك المجانية وجرب التدريب معنا"}
      </p>
      <form className={classes.form} onSubmit={(e) => submitHandler(e)}>
        <div className={classes.formGroup}>
          {form}
        </div>
        <button type="submit" className={classes.submitButton}>
          {parseInt(localStorage.getItem('language')) === 1 ? "SUBMIT" : "إرسال"}
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
            alt=""
            className={classes.submitIcon}
          />
        </button>
      </form>
      {error && <PromptMessage 
        message={error} 
        status={parseInt(localStorage.getItem('language')) === 1 ? 'Oops' : 'عفواً'} 
        button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
        click={() => setError(false)} 
      />}
      {success && <PromptMessage 
        message={success} 
        status={parseInt(localStorage.getItem('language')) === 1 ? 'CONGRATULATIONS' : 'تهانينا'} 
        successMessage 
        button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
        click={() => setSuccess(false)} 
      />}
    </section>
  );
}

export default FreeTrialForm;
